export default __webpack_public_path__ + "static/media/icon-arrow-down.852fa301.svg";